import { Injectable } from '@angular/core'
import { UserSearch } from '../../models/user-search'

@Injectable()
export class UserListService {
    private userSearchParameters: UserSearch;

    constructor() {
        this.reset();
    }

    reset() {
        this.userSearchParameters = {} as UserSearch
    }

    getUserSearchParameters() {
        return this.userSearchParameters;
    }

    setUserSearchParameters(userSearchParameters: UserSearch) {
        this.userSearchParameters = userSearchParameters;
    }

} 
